export const customEvent = {
  lockUser: 'lockUser',
};
